export default __webpack_public_path__ + "static/media/two-heads-new.5748d247.jpg";